// Utils
import cn from '@/utils/cn';

// Styles
import styles from './Heading.module.css';

interface HeadingProps {
  title: string,
  Tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span',
  size?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
  weight?: '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900',
  color?: 'light' | 'dark' | 'red',
  align?: 'left' | 'right' | 'center',
  isSharp?: boolean
}

function extractSpans(text: string) {
  const regex = /\/\/(.*?)\/\//g;
  const parts: (string | { span: string })[] = [];
  let lastIndex = 0;
  let match = regex.exec(text);

  while (match !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push({ span: match[1] });
    lastIndex = regex.lastIndex;
    match = regex.exec(text);
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return parts;
}

function Heading({
  title,
  Tag = 'h1',
  size = 'h1',
  weight = '500',
  color = 'light',
  align = 'left',
  isSharp = false,
}: HeadingProps) {
  
  const content = extractSpans(title);
  return (
    <Tag
      className={cn([
        styles.heading,
        styles[size],
        styles[color],
        styles[`weight-${weight}`],
        styles[`text-${align}`],
      ])}
    >
      {
        content.map(
          (part) => typeof part === 'string' ? part 
            : (
              <span
                key={part.span}
                className={`${styles.highlight} ${isSharp ? styles.sharp : null }`}
              >
                {part.span}
              </span>
            )
        )
      }
    </Tag>
  );
}

export default Heading;